import React from 'react';
import { motion } from 'framer-motion';
export function Transformation() {
  return <section className="py-20 px-6 bg-forest text-cream relative overflow-hidden" data-id="element-130">
      <div className="max-w-6xl mx-auto" data-id="element-131">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-132">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:w-1/2 relative" data-id="element-133">
            <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-sage/20" data-id="element-134">
              <img src="https://cdn.magicpatterns.com/uploads/j6YmQDYr9GyVo1LfSymbwF/concepto_8.png" alt="Mujer disfrutando de su comida preparada" className="w-full h-auto object-cover" data-id="element-135" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:w-1/2" data-id="element-136">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-6 text-white" data-id="element-137">
              ¿Qué cambia en 7 días?
            </h2>

            <div className="space-y-6 text-lg text-sage font-sans leading-relaxed" data-id="element-138">
              <p data-id="element-139">
                La primera semana después de aplicar el Método Freezer-Fit, el
                domingo a la noche vas a sentir una paz que no conocías.
              </p>
              <p className="font-bold text-white text-xl border-l-4 border-terracotta pl-4 py-2" data-id="element-140">
                Vas a mirar tu freezer lleno de viandas ricas y vas a saber que
                mañana, cuando llegues cansada, tu única preocupación va a ser
                elegir qué tupper calentar.
              </p>
              <p data-id="element-141">
                Se acabó la culpa del delivery. Se acabó el estrés de las 7 de
                la tarde. Recuperás tu tiempo, tu plata y tu tranquilidad.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}